"use client";

// @ts-strict-ignore
import { createContext, useContext } from "react";
import type { InlineCTA } from "types/contentful";

export const InlineCTAContext = createContext<{
  data: InlineCTA | null;
}>(null);

export const useInlineCTAData = (): {
  data: InlineCTA | null;
} => {
  const { data } = useContext(InlineCTAContext);
  return { data };
};
